<template>
  <div>
    <div :style="{ background: '#fff', textAlign: 'center' }">
      <a-table
        :columns="columns"
        :row-key="(record) => record.id"
        :data-source="data"
        :pagination="pagination"
        :loading="loading"
        :customRow="selectUser"
      >
        <template slot="avatarURL" slot-scope="avatarURL">
          <a-avatar :src="avatarURL" />
        </template>
        <template slot="owner" slot-scope="text, record">
          <a-avatar :src="record.owner.avatarURL" />
          {{ record.owner.nickname }}
        </template>
        <template slot="total" slot-scope="total">
          {{ total / 100 }} 元
        </template>
        <template slot="createdAt" slot-scope="createdAt">
          {{ new Date(createdAt).toLocaleDateString("zh-CN") }} -
          {{ new Date(createdAt).getHours() }}:{{
            new Date(createdAt).getMinutes()
          }}
        </template>

        <span slot="status" slot-scope="status">
          <a-tag :key="status" :color="status === 'paid' ? 'green' : 'red'">
            {{ status.toUpperCase() }}
          </a-tag>
        </span>
      </a-table>
    </div>
    <Profile :detail="detail" :visible="visible" />
  </div>
</template>


<script>
import "element-ui/lib/theme-chalk/display.css";
const AV = require("leancloud-storage");
import Profile from "../../components/dashboard/userList/Profile";

export default {
  components: { Profile },
  data() {
    return {
      data: [],
      pagination: {},
      loading: false,
      columns: [],
      // --
      detail: {},
      detailWidth: 640,
      visible: false,
      // --
    };
  },
  mounted() {
    this.asyncData();
    if (screen.width <= 440) {
      this.columns = [
        {
          title: "User",
          dataIndex: "owner",
          width: "20%",
          scopedSlots: { customRender: "owner" },
        },
        {
          title: "Status",
          dataIndex: "status",
          width: "10%",
          scopedSlots: { customRender: "status" },
        },

        {
          title: "Total",
          dataIndex: "total",
          width: "15%",
          scopedSlots: { customRender: "total" },
        },
      ];
    } else {
      this.columns = [
        {
          title: "User",
          dataIndex: "owner",
          width: "20%",
          scopedSlots: { customRender: "owner" },
        },
        {
          title: "Status",
          dataIndex: "status",
          width: "10%",
          scopedSlots: { customRender: "status" },
        },

        {
          title: "Order Number",
          dataIndex: "orderNumber",
          width: "20%",
        },
        { title: "Payment Method", dataIndex: "paymentMethod", width: "20%" },
        {
          title: "Total",
          dataIndex: "total",
          width: "15%",
          scopedSlots: { customRender: "total" },
        },
        {
          title: "CreatedAt",
          dataIndex: "createdAt",
          width: "20%",
          scopedSlots: { customRender: "createdAt" },
        },
      ];
    }
  },
  methods: {
    changeHousePlan(houseId, plan, date) {
      console.log(houseId);
      console.log(plan);
      console.log(date);
    },
    afterVisibleChange(val) {
      console.log("visible", val);
    },
    showDrawer() {
      this.visible = true;
    },
    onClose() {
      this.changedHousePlan = {};
      this.visible = false;
    },
    selectUser(record) {
      return {
        on: {
          click: async () => {
            const result = await AV.Cloud.run("fetchAllHouse", {
              ownerId: record.owner.id,
            });
            this.detail = {
              name: record.owner.nickname,
              id: record.owner.id,
              house: result[0],
              houses: result,
            };
            this.showDrawer();
          },
          dblclick: () => {},
        },
      };
    },
    async asyncData() {
      // check token
      // jump sign in
      this.loading = true;
      //   const ip = await this.$axios.$get("/fetchAllOrder");
      const result = await AV.Cloud.run("fetchAllOrder");
      const users = result; //.result;
      //   console.log(users);
      const pagination = { ...this.pagination };
      // Read total count from server
      pagination.total = users.length;
      this.loading = false;
      this.data = users;
      this.pagination = pagination;

      return { result };
    },
    handleTableChange(pagination, filters, sorter) {
      console.log(pagination);
      const pager = { ...this.pagination };
      pager.current = pagination.current;
      this.pagination = pager;
      this.fetch({
        results: pagination.pageSize,
        page: pagination.current,
        sortField: sorter.field,
        sortOrder: sorter.order,
        ...filters,
      });
    },
  },
};
</script>

<style>
#components-layout-demo-fixed-sider .logo {
  height: 32px;
  background: rgba(255, 255, 255, 0.2);
  margin: 16px;
}
</style>
